import Vue from 'vue'
import enums from '@/common/enums'
const agentStates = enums.platforms.rbm.agentStates

Vue.filter('rbmAgentState', agentState => {
  if (agentState === agentStates.new) return 'New'
  if (agentState === agentStates.createRequested) return 'Registration in progress'
  if (agentState === agentStates.created) return 'Registered'
  if (agentState === agentStates.launchRequested) return 'Launch in progress'
  if (agentState === agentStates.launched) return 'Launched'

  return agentState
})
